import React, { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useGetAllObjectiveByPeriodId 
} from '../../Hooks/index';
import {Accordion, Box,Grid,Typography} from '@mui/material';
import TeamAndKrDetail from '../TeamAndKrDetail/TeamAndKrDetail';
import LoadingSpinner from '../../../../components/Progress/LoadingSpinner';

const AllObjectiveDetail = ({periodId,periodsData,teamId}:any) => {
  // const navigate=useNavigate();
  const[allObjective,setAllObjective]=useState<any>();
  // const[objectiveC,setObjectiveC]=useState<any>();
  const[alignEvaluationP,setAlignEvaluationPercentage]=useState<any>();
  const[objectiveEvaluationP,setObjectiveEvaluationPercentage]=useState<any>();
  const[alignKRCount,setAlignKeyResultCount]=useState<any>();
  const[objScore,setObjectiveScore]=useState<any>();
  const[alignSc,setAlignScore]=useState<any>();
  const[keyResultC,setKeyResultCount]=useState<any>();
  const[scoreC,setScore]=useState<any[]>();
  const profileTenantId=useSelector((state:any)=>state.meetings.profileTenantId);
  const{data:objetcideData,isLoading:getObjectiveLoading,isFetched,refetch:getObjectivesAgain}=useGetAllObjectiveByPeriodId(periodId,profileTenantId,teamId)
  const[objectiveAsynOpcState,setObjectiveAsyncOpState]=useState<any>(null);
  const [objectiveId,setObjectiveId]=useState<string|null>(null)
  const[showEditObjective,setShowEditObjective]=useState<Boolean|null>(false);

  let { objectiveScore,keyResultCount,alignScore,alignObjectiveCount,alignKeyResultCount,
      objectiveEvaluationPercentage, alignEvaluationPercentage,verticalKeyResults, name
  } = objetcideData || {}

  useEffect(() => {

    setObjectiveEvaluationPercentage(objectiveEvaluationPercentage)

  }, [objectiveEvaluationPercentage])

  // useEffect(() => {

  //   setObjectiveC(objectiveScore)

  // }, [objectiveScore])

  useEffect(() => {

    setAlignEvaluationPercentage(alignEvaluationPercentage)

  }, [alignEvaluationPercentage])

  useEffect(() => {

    setObjectiveScore(objectiveScore)

  }, [objectiveScore])

  useEffect(() => {

    setAlignKeyResultCount(alignKeyResultCount)

  }, [alignKeyResultCount])

  useEffect(() => {

    setAllObjective(verticalKeyResults)

  }, [verticalKeyResults])

  useEffect(() => {

    setAlignScore(alignScore)

  }, [alignScore])

  useEffect(() => {

    setKeyResultCount(keyResultCount)

  }, [keyResultCount])

  useEffect(() => {

    setScore(alignObjectiveCount)

  }, [alignObjectiveCount])


  useEffect(() => {
      
    if (objectiveId) {
        setShowEditObjective(true)
    }
    }, [objectiveId])


  if ((objetcideData !== null && objetcideData !== undefined)
    &&(getObjectiveLoading || !allObjective || isFetched!==true)
    && (verticalKeyResults !== null && verticalKeyResults !== undefined)
  ) {
    return <Box display={'flex'} 
    alignItems={'center'} 
    justifyContent={'center'} 
    width={'100%'} 
    height={'500px'} 
     >
      <LoadingSpinner  />
     </Box>
  }
  
  return (
    <>
    {
      name === "WithOut" ?
        <Grid item xs={12}  >
        </Grid>:
        <Grid item xs={12}  >
         {
          objetcideData !== null && objetcideData !== undefined ?  
          <Grid display={'flex'}  marginTop={1} flexDirection={'row-reverse'} justifyContent={'space-between'} item xs={12}  >
          <Box 
          borderColor={'#EAEAEA '}
          borderRadius={10}
          boxShadow={5}
          py={2}
          px={2}
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'column'} alignItems={'center'} >
          <Typography fontWeight={600} fontSize={'13px'}>
          تعداد نتیجه کلیدی:  {keyResultC} </Typography> </Box>
          <Box 
          bgcolor={alignEvaluationP>= 70 ?'#d5f7d4' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#FFF8D0': '#FFEEE5'}
          color={alignEvaluationP>= 70 ?'#125610' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#6B6440': '#993600'}
          borderRadius={10}
          boxShadow={5}
          py={2}
          px={2}
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'row'} justifyContent={'center'} alignItems={'center'} >
          <Typography fontWeight={600} fontSize={'13px'}>
          امتیاز هدف:  {objScore} </Typography> </Box>
          <Box 
          bgcolor={alignEvaluationP>= 70 ?'#d5f7d4' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#FFF8D0': '#FFEEE5'}
          color={alignEvaluationP>= 70 ?'#125610' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#6B6440': '#993600'}
          borderRadius={10}
          boxShadow={5}
          py={2}
          px={2}
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'row'} justifyContent={'center'} alignItems={'center'} >
          <Typography fontWeight={600} fontSize={'13px'}>
          امتیاز همسو:  {alignSc} </Typography> </Box>
          {/* <Box 
          borderColor={'#EAEAEA '}
          borderRadius={10}
          boxShadow={10}
          py={2}
          px={2}
  
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'column'} alignItems={'center'} >
          <Typography fontWeight={600}>
          امتیاز هدف:  {objectiveC} </Typography> </Box> */}
          <Box 
          borderColor={'#EAEAEA '}
          borderRadius={10}
          boxShadow={5}
          py={2}
          px={2}
  
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'row'} alignItems={'center'} >
          <Typography fontWeight={600} fontSize={'13px'}>
          تعداد هدف همسو:  {scoreC} </Typography> </Box>
          <Box 
          borderColor={'#EAEAEA '}
          borderRadius={10}
          boxShadow={5}
          py={2}
          px={2}
  
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'row'} alignItems={'center'} >
          <Typography fontWeight={600} fontSize={'13px'}>
          تعداد نتیجه همسو:  {alignKRCount} </Typography> </Box>
          <Box 
          bgcolor={alignEvaluationP>= 70 ?'#d5f7d4' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#FFF8D0': '#FFEEE5'}
          color={alignEvaluationP>= 70 ?'#125610' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#6B6440': '#993600'}
          borderRadius={10}
          boxShadow={5}
          py={2}
          px={2}
  
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'column'} alignItems={'center'} >
          <Typography fontWeight={600} fontSize={'13px'}>
          درصد ارزیابی هدف:  {objectiveEvaluationP} </Typography> </Box>
          <Box 
          bgcolor={alignEvaluationP>= 70 ?'#d5f7d4' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#FFF8D0': '#FFEEE5'}
          color={alignEvaluationP>= 70 ?'#125610' : alignEvaluationP <70 && alignEvaluationP > 30 ? '#6B6440': '#993600'}
          borderRadius={10}
          boxShadow={5}
          py={2}
          px={2}
  
          width={'50%'}
          height={'100%'}
          display={'flex'}
          flexDirection={'row'} justifyContent={'center'} alignItems={'center'} >
          <Typography fontWeight={600} fontSize={'13px'}>
          درصد ارزیابی همسو:  {alignEvaluationP} </Typography> </Box>
          </Grid>:<Grid><Box></Box> </Grid>
         }
        </Grid>
     }
        <Grid item xs={12}  >
         {
          objetcideData !== null && objetcideData !== undefined ?  <Grid container  >
          <Grid item xs={12}  >
            <Grid container spacing={1} px={1} >
           {
            allObjective && allObjective.map((o:any,i:number)=>{
              return <Grid  item xs={12} sm={12}  >
                <Box width={'100%'} key={i}   >
                <TeamAndKrDetail obj={o}   
                afterSuccess={getObjectivesAgain}
                setObjectiveId = {setObjectiveId}
                item={o}
                num = {i}
                namee = {name}
                setShowEditForm={setShowEditObjective}
                setObjectiveAsyncOpState={setObjectiveAsyncOpState}
                />
              </Box>
              </Grid>
            })
          }
           </Grid> 
          </Grid>
         </Grid>:<Grid><Box></Box> </Grid>
         }
        </Grid>
    </>
  )
}

export default AllObjectiveDetail